// APP DETAILS
export const APP_NAME = "Greta's Patchwork - Handmade Patchwork Quilts"
export const APP_DESCRIPTION =
	"Descubre un mundo de productos de patchwork hechos a mano en Greta's Patchwork. Experimenta el encanto de diseños únicos, colores vibrantes y costuras intrincadas. Transforma tu espacio con la calidez y belleza del patchwork hecho a mano. ### Productos exquisitos de patchwork hechos a mano."
export const APP_PRODUCTION_URL = "https://www.gretaspatchwork.com"
export const APP_DEVELOPMENT_URL = "http://localhost:3101"

export const DEFAULT_BLOG_AUTHOR = "Greta"

export const BUSINESS = {
	name: "Greta's Patchwork",
	registeredOffice: "TBD",
	nif: "TBD",
	email: "hello@gretaspatchwork.com",
	registrationData: "TBD",
}

export const BASE_URL =
	process.env.NODE_ENV === "production"
		? APP_PRODUCTION_URL
		: APP_DEVELOPMENT_URL

// FILE UPLOAD
export const MAX_FILE_SIZE = "5MB"
export const ACCEPTED_IMAGE_TYPES = [
	"image/jpeg",
	"image/jpg",
	"image/png",
	"image/webp",
]
export const MAX_FILES = 10
